import { render, staticRenderFns } from "./InputPoints.vue?vue&type=template&id=ccc2faf2"
import script from "./InputPoints.vue?vue&type=script&lang=js"
export * from "./InputPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports